import { render, staticRenderFns } from "./SimulationMenu.vue?vue&type=template&id=e016b862"
import script from "./SimulationMenu.vue?vue&type=script&lang=ts"
export * from "./SimulationMenu.vue?vue&type=script&lang=ts"
import style0 from "./SimulationMenu.vue?vue&type=style&index=0&id=e016b862&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports